import { CssBaseline, ThemeProvider } from '@mui/material';
import Routes from './Routes';
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import esTranslation from './locales/es/translation.json';
import enTranslation from './locales/en/translation.json';
import theme from './theme';

i18n
  .use(initReactI18next)
  .init({
    lng: "es",
    fallbackLng: "es",
    resources: {
      es: { translation: esTranslation },
      en: { translation: enTranslation },
    },
    interpolation: {
      escapeValue: false
    }
  });

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes />
    </ThemeProvider>
  );
};

export default App;
